/**
 * Duplicate routes that should consolidate their ranking signals onto a single
 * canonical URL.
 *
 * The /tools/* name-generator and lyric-video pages are older, thin duplicates
 * of the richer top-level tool pages (same tool, two URLs). We keep them live
 * for users but point rel=canonical at the authoritative twin so Google and the
 * AI answer engines index and rank ONE page instead of splitting signals across
 * two. Applied on BOTH sides so the crawler-served HTML and the JS-rendered DOM
 * agree: server/_core/seo.ts (toCanonicalPath) and client useSEO
 * (normalizeSeoPath). Keys and values are language-agnostic base paths.
 */
export const CANONICAL_CONSOLIDATION: Record<string, string> = {
  "/tools/band-name-generator": "/band-name-generator",
  "/tools/artist-name-generator": "/artist-name-generator",
  "/tools/album-name-generator": "/album-name-generator",
  "/tools/song-name-generator": "/song-title-generator",
  "/tools/lyric-video-generator": "/lyric-video-generator",
  "/tools/lyrics-video-generator": "/lyrics-video-generator",
};

/** Return the canonical base path for a route, collapsing known duplicates. */
export function consolidateCanonicalPath(basePath: string): string {
  return CANONICAL_CONSOLIDATION[basePath] ?? basePath;
}
